module.exports = function UpdateSourceSetRequest(cid, path, bytes) {
    this.cid = cid;
    this.path = path;
    this.bytes = bytes;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-set-request.js
// module id = 497
// module chunks = 1